import { Link } from 'react-router-dom'
import { CenteredCard } from '../components/Shell'

export default function NotFound({ message = 'This page does not exist.' }: { message?: string }) {
  return (
    <CenteredCard index="404">
      <h1 className="text-4xl font-bold">Not found.</h1>
      <p className="mt-3 text-[15px] text-ink-2">{message}</p>
      <Link to="/" className="btn-primary mt-8">
        Go home
      </Link>
    </CenteredCard>
  )
}
